export default function AboutPage() {

    return (<div className="aboutPage">
        <h2>About Scoped</h2>
        <p>ScopedTV is a website for tracking television shows.</p>
        <br></br>
        <div className="aboutPageLinks">
            <p>Television show data from <a href="https://thetvdb.com/" target="_blank">TVDB</a></p> 
            <p>Ranking of shows from <a href="https://www.treasuretv.org/" target="_blank">Treasure TV</a> </p>
            <p>Some icons from <a href="https://iconscout.com/contributors/google-inc" target="_blank">IconScout/Google Inc</a></p>
            <p>Provide feedback <a href="https://forms.gle/AeLbnJRghtrwXErJA" target="_blank">here</a></p>
        </div>
        
    </div>);
}